import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CircleProgressBarComponent } from './circle-progress-bar.component';

@NgModule({
  declarations: [CircleProgressBarComponent],
  imports: [CommonModule],
  exports: [CircleProgressBarComponent],
})
export class CircleProgressBarModule {}
